export const productHeaderGalleryGql = /* GraphQL */ `
... on bodyContent2022_headerGallery_BlockType {
    typeHandle
    sectionTitle
    description
    theme
    links:bcProductHeaderGalleryLinks {
        ... on bcProductHeaderGalleryLinks_BlockType {
            linkStyle:bcProductHeaderGalleryLinkLinkStyle
            enableModal:bcProductHeaderGalleryLinksEnableModal
            disclaimerFootnote:bcProductHeaderGalleryLinksDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:bcProductHeaderGalleryLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            title
            altText
            caption
            cardDescription
            thumbnailSize:galleryThumbnail {
                srcset
                srcWebp
            }
            fullSize:lpImageTextUncropped {
                srcWebp
                srcset
            }
        }
    }
}`;
